export interface Role {
  id: string;
  label: string;
  children: Role[];
}

let cachedRoles: Role[] | null = null;

export function getCachedRoles(): Role[] | null {
  return cachedRoles;
}

export function setCachedRoles(roles: Role[]): void {
  cachedRoles = roles;
}

export function clearRolesCache(): void {
  cachedRoles = null;
}
